namespace Shared.IllyAdmin.Hilos

type HiloMetadata =
    {
        TargetTables: string
        HiloTable: string
        Column: string
        Value: int
    }

module HiloMetadata =
    let empty =
        {
            TargetTables = ""
            HiloTable = ""
            Column = ""
            Value = 0            
        }